import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import MobileDetect from "mobile-detect";
import React from "react";
import ImprimirDialog from "./ImprimirDialog";

const styles = () => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        border: "1px solid #d2d2d2",
    },
});

const md = new MobileDetect(window.navigator.userAgent);

const NewState = {
    open: null
};

class ImprimirApp extends XAPPComponent {

    state = { ...NewState };

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
    };

    render() {
        const { open } = this.state;
        const { label, className, xappRouteParams, disabled, data, id, color = null, column, type = "Fab", idrelatorio, children } = this.props;

        return (
            <React.Fragment>
                {data !== null &&
                    <React.Fragment>
                        {type === "children" ?
                            <div className='cursor-pointer' onClick={() => this.openDialog({})}>
                                {children}
                            </div>
                            :
                            <XAPPButton
                                type={type}
                                color={!_.isNull(color) ? color : "primary"}
                                className={!_.isUndefined(className) ? className : "text-white"}
                                onClick={() => this.openDialog({})}
                                variant="contained"
                                icon="print"
                                disabled={disabled}
                                label={type.toLowerCase() === "button" && (_.isNull(md.mobile()) && _.isNull(md.tablet()) ? "Imprimir" : "")}
                                iconProps={type.toLowerCase() === "button" && (_.isNull(md.mobile()) && _.isNull(md.tablet()) ? "mr-8" : "justify-center")}
                                tooltip={{ "title": "Imprimir", "placement": "top" }}
                            />
                        }
                    </React.Fragment>
                }
                <ImprimirDialog
                    open={open}
                    openDialog={this.openDialog}
                    xappRouteParams={xappRouteParams}
                    data={data}
                    id={id}
                    column={column}
                    label={label}
                    idrelatorio={idrelatorio}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(ImprimirApp);
